import Entity from "./Entity";

export default class Rect extends Entity {
    
    constructor(data) {
        super(data);

        this.attributeKeys = [ "top", "left", "bottom", "right" ];
    }
}